import React from "react";
import { Row, Col, Divider, Button } from "antd";
import { Link } from "react-router-dom";
import Moment from "moment";

import Confirmation from "../common/confirmation";

const CampaignList = ({
  campaign,
  modalState,
  onOpen,
  onClose,
  confirm,
  editDraft
}) => {
  return (
    <div>
      <div>
        <Confirmation
          title="Delete Campaign"
          modalState={modalState}
          confirm={confirm}
          onClose={onClose}
          message="Are you sure you want to delete campaign?"
        />
        <Row style={{ paddingBottom: 10, paddingTop: 10 }}>
          <Col span={2}>
            <img
              alt="Campaign Icon"
              src="/assets/img/survey.png"
              style={{ width: "40%", marginTop: 15 }}
            />
          </Col>
          <Col span={6}>
            <Link to="" style={{ fontSize: "1.3rem", marginTop: 40 }}>
              {campaign.title}
            </Link>
            <p style={{ fontSize: "1.1rem" }}>{campaign.subject}</p>
            <p style={{ fontSize: "0.9rem", marginTop: -15, color: "#BDBDBD" }}>
              {Moment(campaign.createdAt.toDate()).format("MM/DD/YYYY")}
            </p>
          </Col>
          <Col span={10}>
            <p style={{ marginTop: 25 }} />
            <p style={{ fontSize: "1.1rem" }}>Status</p>
            <p
              style={
                campaign.status === "draft"
                  ? { fontSize: "0.9rem", marginTop: -15, color: "orange" }
                  : { fontSize: "0.9rem", marginTop: -15, color: "green" }
              }
            >
              {campaign.status.toUpperCase()}
            </p>
          </Col>
          <Col span={6}>
            <Button
              type="danger"
              onClick={() => onOpen(campaign)}
              style={{ float: "right", marginRight: 10, marginTop: 15 }}
            >
              Delete
            </Button>
            {campaign.status === "draft" && (
              <Button
                type="default"
                onClick={() => editDraft(campaign)}
                style={{ float: "right", marginRight: 10, marginTop: 15 }}
              >
                Edit
              </Button>
            )}
          </Col>
        </Row>
        <Divider />
      </div>
    </div>
  );
};

export default CampaignList;
